import React from 'react';
import { Box, Grid, Paper, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { AuthPageStyles } from '../../authentication/styles';
import { useLocation } from 'react-router';
import { LocationState } from './../interfaces/locationState';
import { useAppSelector } from '../../redux-store/hook';

/** Component for general error page with localized message 'Internal Server Error '*/
const ErrorPage = (): JSX.Element => {
  const location: LocationState = useLocation();
  const { t } = useTranslation();
  const theme = useTheme();
  const lgUp = useMediaQuery(theme.breakpoints.up('lg'));
  const { isICPEnabled } = useAppSelector((state) => state.headerDetails);
  const classes = AuthPageStyles({ isICPEnabled: isICPEnabled });

  return (
    <Grid container justify="center" className={classes.container}>
      <Grid item xl={8} lg={10} className={classes.grid}>
        <Paper elevation={lgUp ? 1 : 0} className={classes.paper}>
          <Box textAlign="center">
            <Typography variant="body1" color="error">
              {location?.state?.message ? location.state.message : t('internalServerError')}
            </Typography>
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default ErrorPage;
